import configureApi from '@sleepstation/api-rest'
import loggingApi, { configureLoggingApi } from '@sleepstation/logger'
import { isRunningInBrowser } from '@sleepstation/utils'
import memoize from 'fast-memoize'
import { Link } from 'react-router-dom'
import AnchorLink from '../components/shared/AnchorLink'
import LOG_GROUP from '../const/logGroup'
import { isTestBuild } from '../helpers/environment'
import configureGoogleTagManager from './configureGoogleTagManager'
import getErrorReporter from './getErrorReporter'
// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const logger = loggingApi.getLogger({ group: LOG_GROUP.STARTUP })

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const startup = memoize((environment) => {
  const { SERVICE, HOST, ORIGIN } = environment

  logger.info(`Starting up …`)

  if (isRunningInBrowser()) {
    configureLoggingApi({
      environment: process.env.ACTIVE_ENV,
      filter: {
        includedGroups: [],
      },
    })
  }

  // Configure Tag Manager
  const dataLayer = configureGoogleTagManager()

  // We disable Google Recaptcha when under test
  const recaptchaIsEnabled = !isTestBuild()

  // Note that the underlying library (Sentry) is initialized as early in the
  // app's lifecycle as possible, so that also it catches errors that happen
  // earlier in the lifecyle before this point.
  const errorReporter = getErrorReporter()

  const restApi = configureApi(ORIGIN, errorReporter)

  const linkContext = {
    // Map of tokens that will be replaced in any link URLs
    tokenMap: {
      railsApp: HOST.APP,
      wwwSite: HOST.WWW,
    },
    LinkComponent: Link,
    AnchorComponent: AnchorLink,
  }

  const recaptchaKeyContext = {
    recaptchaIsEnabled,
    recaptchaSiteKey: SERVICE.RECAPTCHA.KEY,
    shouldComponentLoadScript: false,
  }

  logger.info(`Startup complete`)

  return {
    dataLayer,
    errorReporter,
    restApi,
    linkContext,
    recaptchaKeyContext,
  }
})

export default startup
